import { inject, injectable } from 'inversify';
import 'reflect-metadata';

import { ClientStorageService } from '@/modules/common/services/client-storage.service';
import { get } from '@api/api-client';
import { IAgriculture } from '@@/agriculture/ts';
import { DiContainer } from '@@/di/di-container';

@injectable()
export class AgricultureService implements IAgricultureService {
  private readonly STORAGE_KEY = 'cultures';

  // not working because of babel settings
  // constructor(
  //   @inject(ClientStorageService)
  //   private readonly clientStorageService: ClientStorageService,
  // ) {}
  constructor(
    private readonly clientStorageService = DiContainer.get(ClientStorageService),
  ) {}

  getCultures() {
    return get<Array<IAgriculture>>(`${PUBLIC_API_URL}/agriculture`);
  }
  
  async getAndSaveCulturesToStorage() {
    const response = await this.getCultures();
    this.saveCulturesToStorage(response);

    return response;
  }

  getCulturesFromStorage() {
    return this.clientStorageService.get<Array<IAgriculture>>(this.STORAGE_KEY);
  }

  saveCulturesToStorage(cultures: Array<IAgriculture>) {
    this.clientStorageService.set(this.STORAGE_KEY, cultures);
  }
}

export interface IAgricultureService {
  getCultures(): Promise<Array<IAgriculture>>;
  getAndSaveCulturesToStorage(): Promise<Array<IAgriculture>>;
  getCulturesFromStorage(): Array<IAgriculture> | null | void;
  saveCulturesToStorage(cultures: Array<IAgriculture>): void;
}
